import React from "react";

export default function ProgressBar({ label, value }: { label: string; value: number }) {
  const pct = Math.max(0, Math.min(100, value ?? 0));
  return (
    <div className="score-row" style={{ margin: ".6rem 0" }}>
      <span style={{ minWidth: 140, display: "inline-block" }}>{label}</span>
      <div className="bar" style={{
        height: 10, background: "#0b1b2b", borderRadius: 999, overflow: "hidden",
        border: "1px solid #0e2238", flex: 1, margin: "0 .75rem"
      }}>
        <div className="bar-fill" style={{
          height: "100%", width: pct + "%",
          background: "linear-gradient(90deg,#38bdf8,#7dd3fc)"
        }}/>
      </div>
      <span className="score" style={{ fontWeight: 700, color: "#cbd5e1", minWidth: 32, textAlign: "right" }}>
        {pct}
      </span>
    </div>
  );
}
